import React from 'react';

interface PrimePickBadgeProps {
  iconOnly?: boolean;
}

const PrimePickBadge: React.FC<PrimePickBadgeProps> = ({ iconOnly = false }) => (
  <span
    className="inline-flex items-center gap-0.5 rounded-full font-bold"
    style={{
      background: 'linear-gradient(135deg, #F1C40F, #F39C12)',
      color: '#1a1a1a',
      ...(iconOnly
        ? { padding: '2px', fontSize: '0' }
        : { padding: '2px 8px', fontSize: '0.75rem' }),
    }}
    title="Prime Pick — both of our models selected this horse as their #1 tip"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
    {!iconOnly && ' Prime Pick'}
  </span>
);

export default PrimePickBadge;
